<div *ngIf="isHeader" class="review-overview">
    <star-rating
      *ngIf="reviewSummary.avgRating"
      [ngClass]="'review-overview__stars' + sizeModifier"
      [starType]="'svg'"
      [rating]="reviewSummary.avgRating"
      [step]="0.1"
      [showHalfStars]="true"
      [staticColor]='"ok"'
      [readOnly]="true">
    </star-rating>
    <!-- show counts on one line if not part of the header -->
    <div class="review-overview__counts">
      <span *ngIf="reviewSummary.countRatings; else ratingPlaceholder" [ngClass]="'review-overview__count' + sizeModifier">
        {{ ratingLabel }}
      </span> |
      <span *ngIf="reviewSummary.countReviews; else reviewPlaceholder" [ngClass]="'review-overview__count' + sizeModifier">
        {{ reviewLabel }}
      </span>
    </div>
</div>

<div *ngIf="!isHeader" class="review-overview__column">
  <div class="review-overview__vertical_block">
    <span class="review-overview__feature-header-overall">Overall:</span>
    <star-rating
      *ngIf="reviewSummary.avgRating"
      [ngClass]="'review-overview__stars' + sizeModifier"
      [starType]="'svg'"
      [rating]="reviewSummary.avgRating"
      [step]="0.1"
      [showHalfStars]="true"
      [staticColor]='"ok"'
      [readOnly]="true">
    </star-rating>
  </div>
  <!-- show counts on a new line if part of the header -->
  <div class="review-overview__counts">
      <span *ngIf="reviewSummary.countRatings; else ratingPlaceholderNoHeader" class="review-overview__count-non-header">
        {{ ratingLabel }}
      </span> <span class="review-overview__count-non-header"> | </span>
      <span *ngIf="reviewSummary.countReviews; else reviewPlaceholderNoHeader" class="review-overview__count-non-header">
        {{ reviewLabel }}
      </span>
  </div>
  <div class="review-overview__vertical_block" *ngFor="let subCat of reviewSummary.avgSubRatings">
    <span class="review-overview__feature-header">{{ subCat.feature }}:</span>
    <star-rating
      *ngIf="subCat.rating; else noSubRating"
      [ngClass]="'review-overview__stars' + sizeModifier"
      [starType]="'svg'"
      [rating]="subCat.rating"
      [step]="0.1"
      [showHalfStars]="true"
      [staticColor]='"ok"'
      [readOnly]="true">
    </star-rating>
  </div>
  <div class="review-overview__sort-select">
    <div class="review-overview__sort-text">
      Sort By:
    </div>
    <mat-select class="review-overview__sort-select-field" [formControl]="sortBy" (selectionChange)="reSort($event.value)">
      <mat-option value="likes">Top Reviews</mat-option>
      <mat-option value="date">Most Recent</mat-option>
    </mat-select>
  </div>
</div>

<ng-template #ratingPlaceholder>
  <span [ngClass]="'review-overview__placeholder' + sizeModifier">No ratings</span>
</ng-template>
<ng-template #reviewPlaceholder>
  <span [ngClass]="'review-overview__placeholder' + sizeModifier">{{noReviewsText}}</span>
</ng-template>
<ng-template #ratingPlaceholderNoHeader>
  <span class="review-overview__count-non-header">No ratings</span>
</ng-template>
<ng-template #reviewPlaceholderNoHeader>
  <span class="review-overview__count-non-header">{{noReviewsText}}</span>
</ng-template>
<ng-template #noSubRating>
  <span class="review-overview__stars">No ratings</span>
</ng-template>
